import { AxiosResponse } from 'axios';
import { useAxios } from '../../composables/axios';
import { Document } from './document.model';

const axios = useAxios();

export interface DocumentService {
  Fetch: () => Promise<AxiosResponse<Document[]>>;
}

const Fetch = (): Promise<AxiosResponse<Document[]>> =>
  axios.Get<Document[]>('api/documents');

export default { Fetch } as DocumentService;
